import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website',
  article = null 
}) => {
  const siteTitle = 'Just Travel - Budget Reisen, Reisetipps & Reiseziele weltweit';
  const fullTitle = title ? `${title} | Just Travel` : siteTitle;
  const defaultDescription = 'Entdecke die Welt mit kleinem Budget! Just Travel bietet dir preiswerte Reisetipps, Destination Guides, Packlisten und Insider-Spartipps für über 20 Reiseziele weltweit.';
  const siteUrl = 'https://www.just-travels.com';
  const defaultImage = 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1200';

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url || siteUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url || siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:site_name" content="Just Travel" />
      <meta property="og:locale" content="de_DE" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url || siteUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={image || defaultImage} />

      {/* Article specific tags */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          <meta property="article:author" content={article.author || 'Thomas & Jasmin'} />
          {article.tags && article.tags.map(tag => (
            <meta key={tag} property="article:tag" content={tag} />
          ))}
        </>
      )}

      {/* Additional SEO */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="German" />
      <meta name="author" content="Jasmin Zentgraf" />
    </Helmet>
  );
};

export default SEO;
